import { render } from "./OurEnvironment.vue?vue&type=template&id=2b082835&scoped=true"
import script from "./OurEnvironment.vue?vue&type=script&lang=js"
export * from "./OurEnvironment.vue?vue&type=script&lang=js"

import "./OurEnvironment.vue?vue&type=style&index=0&id=2b082835&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b082835"]])

export default __exports__